import * as PIXI from 'pixi.js';
import { dispatch, state } from '__common/store';
import { ADD_ENDING_POINT, ADD_STARTING_POINT, DELETE_MEASUREMENT, RESET_CURRENT_MEASUREMENT, START_NEW_MEASUREMENT } from '__editor/googleMapsRoofsSelector/components/measurementTool/measurementToolActions';

function getMeasurementInteractiveObject(displayObject: any) {
  let current = displayObject;

  while (current) {
    if (current.name === 'measurementToolInteractive') {
      return current;
    }

    current = current.parent;
  }

  return null;
}

function getMeasurementInteractiveObjects(displayObject: any): any[] {
  if (!displayObject) {
    return [];
  }

  const measurements: any[] = [];
  const walk = (object: any) => {
    if (object.name === 'measurementToolInteractive') {
      measurements.push(object);
    }

    if (object.children && object.children.length) {
      object.children.forEach(walk);
    }
  };

  walk(displayObject);
  return measurements;
}

function getHitMeasurement(renderer: PIXI.Renderer, stage: PIXI.Container, globalPoint: PIXI.Point) {
  const rendererHitObject = (renderer as any).events?.rootBoundary?.hitTest(globalPoint.x, globalPoint.y);
  const rendererHitMeasurement = getMeasurementInteractiveObject(rendererHitObject);
  if (rendererHitMeasurement) {
    return rendererHitMeasurement;
  }

  const measurements = getMeasurementInteractiveObjects(stage);

  return measurements.find(measurement => {
    const bounds = measurement.getBounds();
    return globalPoint.x >= bounds.x &&
      globalPoint.x <= bounds.x + bounds.width &&
      globalPoint.y >= bounds.y &&
      globalPoint.y <= bounds.y + bounds.height;
  });
}

function updateMeasurementHover(renderer: PIXI.Renderer, stage: PIXI.Container, globalPoint: PIXI.Point) {
  const hitMeasurement = getHitMeasurement(renderer, stage, globalPoint);
  const measurements = getMeasurementInteractiveObjects(stage);

  return measurements.reduce((changed, measurement) => {
    if (measurement === hitMeasurement && typeof measurement.showDeleteControls === 'function') {
      return measurement.showDeleteControls() || changed;
    }

    if (typeof measurement.hideDeleteControls === 'function') {
      return measurement.hideDeleteControls() || changed;
    }

    return changed;
  }, false);
}

export function measurementToolClick(renderer: PIXI.Renderer, stage: PIXI.Container, event?: any) {
  if (event && event.data && event.data.global) {
    const globalPoint = event.data.global;

    const hitMeasurement = getHitMeasurement(renderer, stage, globalPoint);
    if (hitMeasurement) {
      if (getMeasurementInteractiveObject(event.target)) {
        return;
      }

      if (Number.isInteger(hitMeasurement.measurementIndex)) {
        dispatch(DELETE_MEASUREMENT(hitMeasurement.measurementIndex));
      } else {
        dispatch(RESET_CURRENT_MEASUREMENT());
      }

      window.dispatchEvent(new CustomEvent('REFRESH_MEASUREMENT_TOOL'));
      return;
    }

    const { measurementTool : { enabled, startingPoint } } = state();
    const coords = stage.toLocal(globalPoint);
    if (enabled && coords) {
      if (startingPoint){
        dispatch(START_NEW_MEASUREMENT());
      } else {
        dispatch(ADD_STARTING_POINT(coords));
      }
    }
  }
}

export function measurementToolMove(renderer: PIXI.Renderer, stage: PIXI.Container, event?: any) {
  const { measurementTool : { enabled, startingPoint } } = state();
  if (event && event.data && event.data.global) {
    const hoverChanged = updateMeasurementHover(renderer, stage, event.data.global);
    if (hoverChanged) {
      renderer.render(stage);
    }

    const coords = stage.toLocal(event.data.global);
    if (enabled && startingPoint && coords && Number.isFinite(coords.x) && Number.isFinite(coords.y)) {
      dispatch(ADD_ENDING_POINT(coords));
    }
  }
}
